export default function ImageContent(props:{url:string}) {
    return <div className="canvas">
        <img src={props.url}/>
    </div>
}